module.exports = __webpack_public_path__ + "static/img/logo.f186684.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/head/logo.png
// module id = APwA
// module chunks = 3